import Crud from '../views/Worker/Crud'
import Entity from '../views/Worker/Add'
import View from '../views/Worker/View'

let routes = {
    path: '/workers',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/workers/view/:id?',
            name: 'ViewWorker',
            component: View,
            meta: {
                pageTitle: 'Worker',
                breadcrumb: [
                    {
                        text: 'List',
                        active: false,
                        to: '/workers'
                    },
                    {
                        text: 'View',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/workers/add',
            name: 'NewWorker',
            component: Entity,
            meta: {
                pageTitle: 'Worker',
                breadcrumb: [
                    {
                        text: 'List',
                        active: false,
                        to: '/workers'
                    },
                    {
                        text: 'Add',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/workers/edit/:id?',
            name: 'EditWorker',
            component: Entity,
            meta: {
                pageTitle: 'Worker',
                breadcrumb: [
                    {
                        text: 'List',
                        active: false,
                        to: '/workers'
                    },
                    {
                        text: 'Edit',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/workers',
            name: 'list-workers',
            component: Crud,
            meta: {
                pageTitle: 'Workers',
                breadcrumb: [
                    {
                        text: 'List',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
